import React from "react";
import { connect } from "react-redux";

const ContextMenu = ({ options, display, ...props }) => {
  let multSelect = props.detalhes.multSelect;
  // console.log("context: ", display)
  let _options =
    options &&
    options.filter(
      (option) =>
        option.enabled && (multSelect.length <= 1 || option.multSelect)
    );

  let zebraIndex = 0;

  return _options && display ? (
    <ul
      className="card px-2 py-2 m-0 border d-print-none"
      id="context-menu"
      style={{
        minWidth: "100px",
        maxHeight: 24 * _options + "px",
        position: "absolute",
        top: display.y,
        left: display.x,
        listStyle: "none",
        zIndex: 9999,
        display: display.up ? "block" : "none",
        borderWidth: "1px",
        borderColor: "#bdbdbd", // cinza claro
        borderRadius: "12px",
        // Sombreamento acentuado na parte inferior direita (reduzido)
        // boxShadow original:
        // "0 6px 18px 4px rgba(0,0,0,0.18), 0 10px 24px 6px rgba(0,0,0,0.12), 0 1px 4px 0 rgba(0,0,0,0.10)",
        // Reduzido:
        boxShadow:
          "0 2px 6px 1px rgba(0,0,0,0.10), 0 2px 8px 2px rgba(0,0,0,0.08), 0 1px 2px 0 rgba(0,0,0,0.06)",
      }}
    >
      {options &&
        options.length > 0 &&
        options.map((option) => {
          let enabled =
            option.enabled && (multSelect.length <= 1 || option.multSelect);

          if (enabled) {
            zebraIndex++;
            return (
              <li
                onClick={() => {
                  if (enabled) listenToClick(option.action, option);
                }}
                onMouseOver={(e) => {
                  if (enabled) e.currentTarget.classList.add(option.colorClass);
                }}
                onMouseOut={(e) => {
                  e.currentTarget.classList.remove(option.colorClass);
                }}
                key={option.id}
                className={"my-0"}
                title={
                  props &&
                    props.detalhes &&
                    props.detalhes.averbacao_solicitada &&
                    option.action == "solicitarAverbacao"
                    ? "Consulta a anuência da Averbação"
                    : option.tip
                }
                style={{
                  cursor: enabled ? "pointer" : "text",
                  fontSize: "0.85em",
                  color: enabled ? "#000" : "#d3d3d3",
                  backgroundColor: zebraIndex % 2 === 0 ? "#ffffff" : "#ebebeb",
                  borderRadius: "6px",
                  padding: "2px 8px"
                }}
              >
                <i className={option.icon} style={{ marginRight: "5px" }} />
                {props &&
                  props.detalhes &&
                  props.detalhes.averbacao_solicitada &&
                  option.action == "solicitarAverbacao"
                  ? "Consultar Averbação"
                  : props &&
                    props.detalhes &&
                    props.detalhes.posicao &&
                    props.detalhes.posicao.toLowerCase() ==
                    "assinando ccb" &&
                    option.action == "enviarParaAssinatura"
                    ? "Reenviar para Assinatura"
                    : option.title}
              </li>
            );
          }
        })}
    </ul>
  ) : null;
};

const listenToClick = (action, option) => {
  console.log("context.listenToClick: ", { action, option })
  localStorage.setItem("action", action);
  if (option.checklist)
    localStorage.setItem("checklist", "true");
};

function mapStateToProps(state) {
  return {
    proposta: state.dados.proposta,
    detalhes: state.dados.detalhes,
    cliente: state.dados.cliente,
  };
}

export default connect(mapStateToProps)(ContextMenu);
